import { Component } from '@angular/core';

@Component({
  selector: 'app-visitor-tickets',
  templateUrl: './visitor-tickets.component.html',
  styleUrls: ['./visitor-tickets.component.scss']
})
export class VisitorTicketsComponent {

}
